import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NvAppBarComponent } from './components/app-bar/nv-app-bar.component';

export function initializeIcons(reg: MatIconRegistry, san: DomSanitizer): Promise<any> {
    reg.addSvgIcon('gfnBranding', san.bypassSecurityTrustResourceUrl('./assets/img/nv-gfn-logo_v3.svg'));
    return Promise.resolve();
}

export function initializeIconFactory(reg: MatIconRegistry, san: DomSanitizer) {
    const x = () => initializeIcons(reg, san);
    return x;
}

export let iconFactoryProvider = {
    provide: APP_INITIALIZER,
    useFactory: initializeIconFactory,
    deps: [MatIconRegistry, DomSanitizer],
    multi: true
};

@NgModule({
    imports: [NvAppBarComponent],
    exports: [NvAppBarComponent],
    providers: [iconFactoryProvider]
})
export class AppBarModule {}
